module.exports = __webpack_public_path__ + "static/img/transparent_movie.451a0dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/transparent_movie.png
// module id = 585
// module chunks = 1